<template>
    <div class="wrapper wrapper0">
        <a
            href="https://xyx.web.sdo.com/web7/guide/default.aspx"
            target="_blank"
            class="logo"
        ></a>
        <div class="box">
            <a
                target="_blank"
                href="https://xyx.web.sdo.com/web7/guide/default.aspx"
                class="home"
            ></a>
            <ul>
                <li>
                    <a
                        href="https://xyx.web.sdo.com/register/index.html"
                        target="_blank"
                    ></a>
                </li>
                <li>
                    <a
                        href="https://xyx.web.sdo.com/web6/download.html"
                        target="_blank"
                    ></a>
                </li>
            </ul>
            <div class="code-wrapper">
                <div class="code">
                    <div>CX666</div>
                    <span class="copy">复制</span>
                </div>
                <p>
                    新区开启后前往NPC神秘仙子<strong>
                        （天风大陆 （613,631）） </strong
                    >处输入礼包码兑换
                </p>
            </div>
        </div>
        <!-- <div class="btn-video" @click="videoPlay"></div> -->
    </div>
    <Teleport to=".container">
        <div class="qwcode"></div>
        <Transition name="pop">
            <div id="videoPop" class="pop" v-if="state.show">
                <div class="content">
                    <span class="close" @click="closeVideo"></span>
                    <video
                        ref="videoRef"
                        controls="controls"
                        height="500"
                        width="886"
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/hot.mp4"
                    ></video>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script setup>
import Clipboard from "clipboard";
import { ref, reactive, onMounted, nextTick } from "vue";
const videoRef = ref(null);

const state = reactive({
    show: false
});

onMounted(() => {
    const clipboard = new Clipboard(".copy", {
        text: function () {
            return "CX666";
        }
    });
    clipboard.on("success", function () {
        CsGame.alert("礼包码复制成功！", 1200, "success");
    });
});

const videoPlay = () => {
    state.show = true;
    nextTick(() => {
        videoRef.value.play();
    });
};
const closeVideo = () => {
    videoRef.value.pause();
    state.show = false;
};
</script>

<style lang="scss" scoped>
@keyframes Bigger {
    from {
        transform: scale(0.88);
    }

    to {
        transform: scale(1);
    }
}
.icon {
    background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0902_Baidu/icon.png");
    background-repeat: no-repeat;
}
.wrapper0 {
    position: relative;
    height: 1080px;
    background: url("https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/1.jpg")
        no-repeat top center;
    .logo {
        background: url("https://static.web.sdo.com/xyx/pic/act/2025/0902_Baidu/logo.png");
        position: absolute;
        width: 176px;
        height: 101px;
        left: 40px;
        top: 20px;
        z-index: 2;
    }
    &::before {
        position: absolute;
        content: "";
        background: url("https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/title.png");
        width: 1197px;
        height: 295px;
        bottom: 300px;
        left: 50%;
        margin-left: -600px;
        animation: bounceIn 0.6s ease-in-out both;
    }
    .box {
        position: absolute;
        background: url("https://static.web.sdo.com/xyx/pic/act/2025/0902_Baidu/box.png");
        width: 663px;
        height: 247px;
        left: 50%;
        margin-left: -331.5px;
        bottom: 40px;
        color: #a0793a;
        animation: fadeInUp 0.6s 0.6s ease-in-out both;
        .home {
            position: absolute;
            @extend .icon;
            width: 25px;
            height: 74px;
            z-index: 2;
            background-position: -665px -3px;
            right: -18px;
            top: 20px;
            &:hover {
                background-position: -721px -3px;
            }
        }
        ul {
            position: absolute;
            left: 42px;
            top: 40px;
            li {
                margin-bottom: 26px;
                a {
                    width: 211px;
                    height: 63px;
                    display: block;
                    @extend .icon;
                }
                &:nth-of-type(1) a {
                    background-position: 0px 0px;
                    &:hover {
                        background-position: -278px 0px;
                    }
                }
                &:nth-of-type(2) a {
                    background-position: 0px -90px;
                    &:hover {
                        background-position: -278px -90px;
                    }
                }
            }
        }
        .code-wrapper {
            position: absolute;
            width: 300px;
            right: 34px;
            top: 90px;
            line-height: 1.4;
            .code {
                display: flex;
                height: 44px;
                margin-bottom: 12px;
                align-items: center;
                line-height: 44px;
                border: 1px solid #eac07d;
                background: linear-gradient(
                    to bottom,
                    #bb9761,
                    #f9cd85,
                    #bb9761
                );
                div {
                    flex: 1;
                    color: #231412;
                    font-size: 28px;
                    text-align: center;
                }
                span {
                    height: 42px;
                    width: 100px;
                    cursor: pointer;
                    color: #f9cd85;
                    text-align: center;
                    background: linear-gradient(to bottom, #532215, #992420);
                    &:hover {
                        background: linear-gradient(
                            to bottom,
                            #992420,
                            #b05c2c
                        );
                    }
                }
            }
            strong {
                color: #eac07d;
            }
        }
    }
    .btn-video {
        position: absolute;
        z-index: 3;
        width: 86px;
        height: 92px;
        left: 50%;
        margin-left: 304px;
        top: 452px;
        cursor: pointer;
        animation: Bigger 0.4s ease-in-out infinite alternate;
        background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/video-btn.png");
    }
}
.qwcode {
    position: fixed;
    z-index: 2;
    width: 163px;
    height: 289px;
    left: 20px;
    bottom: 40px;
    background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/qw-code.png");
}
#videoPop {
    .content {
        padding: 0px;
        width: 890px;
        height: 504px;
        border: 2px solid #f3ae0d;
    }
}
@media only screen and (min-width: 1920px) {
    .qwcode {
        left: 50%;
        margin-left: -960px;
    }
}
</style>
